/*
Note:
- Frame: "DESIGN" has to be set by default,
otherwise CGE API will return 'null' response
on requestStep3. The value "DESIGN" should be
set for this property for all models and
configurations.
- WindowPanel: true will be set by default,
this is however only relevant if user selects
window in step 4.
- Whenever FrameType is set or updated, some
additional Uterum properties are reset to
default values as well.
- We let the CGE add and handle all other
properties and their default values,
throughout step 3 and step 4 where the
conservatory (uterum) configuration is done.
*/

export const defaultState = {
  Frame: "DESIGN",
  WindowPanel: true,
};
